import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useDispatch } from 'react-redux';
import { IconButton } from '@mui/material';

export function ActionCell({ params }) {
    const dispatch = useDispatch();
    return (
        <>
            <IconButton color='warning' onClick={() => { dispatch({ type: "EDIT", data: params.data }) }}>
                <EditIcon fontSize='inherit' />
            </IconButton>
            <IconButton color="error" onClick={() => { dispatch({ type: "DELETE", data: params.data }) }} >
                <DeleteIcon fontSize='inherit' />
            </IconButton>
            <IconButton color="info" onClick={() => { dispatch({ type: "VIEW", data: params.data }) }} >
                <VisibilityIcon fontSize='inherit' />
            </IconButton>
        </>
    )
}